import styled from "styled-components";

export const NewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 20px;
  width: 100%;
`;

export const NewsCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background: #ffffff;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  padding: 20px;
  width: 100%;
`;

export const NewsTitle = styled.h2`
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5em;
  color: #181d27;
  text-align: left;
  margin: 0;
`;

export const ShowMoreButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #535862;
  text-align: left;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:focus {
    outline: 2px solid #535862;
    outline-offset: 2px;
  }

  &:active:not(:disabled) {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e9eaeb;
`;

export const NewsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
`;

export const NewsItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 46px;
  padding: 12px 20px;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }

  @media (max-width: 768px) {
    gap: 16px;
    padding: 12px 16px;
    flex-direction: column;
  }
`;

export const NewsTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 293px;

  @media (max-width: 768px) {
    width: auto;
    flex: 1;
    min-width: 0;
  }
`;

export const NewsSource = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #535862;
  text-align: left;
`;

export const NewsHeadline = styled.h3`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #181d27;
  text-align: left;
  margin: 0;
  width: 100%;
`;

export const NewsTimestamp = styled.div`
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #535862;
  text-align: left;
`;

export const NewsImage = styled.img`
  width: 155px;
  height: 80px;
  background: linear-gradient(
    90deg,
    rgba(83, 88, 98, 1) 0%,
    rgba(113, 118, 128, 1) 100%
  );
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 120px;
    height: 60px;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  color: #535862;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  color: #d32f2f;
  text-align: center;
`;

export const RetryButton = styled.button`
  margin-left: 8px;
  text-decoration: underline;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  font: inherit;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:focus {
    outline: 2px solid #535862;
    outline-offset: 2px;
  }
`;

export const NewsScrollContainer = styled.div`
  height: 450px; /* Fixed height for exactly 3 news items (145px each) */
  overflow-y: auto;
  padding-right: 8px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  @media (max-width: 768px) {
    height: 210px; /* Slightly smaller on mobile */
    padding-right: 4px;
  }
`;
